<div (click)="selectEvent()" class="eventCard mx-1 my-2" [ngClass]="{'selected-card':event.IsSelected}">
    <div class="row p-0 m-0">
        <p class="col pt-1 m-0 px-2"><i>{{event.EventId}} </i><b>{{event.Title}}</b></p>
        <p *ngIf="event.RecursionRuleId != 0" class="col-auto pt-1 m-0 px-2"><i class="fa fa-refresh"></i></p>
    </div>

    <!-- Timeframe Display -->
    <p *ngIf="IsMultiDayEvent" class="pt-1 m-0 px-2">{{event.StartDateTime | date:'MM/dd/yyyy'}} {{event.StartDateTime | date:'HH:mm'}} - {{event.EndDateTime | date: 'MM/dd/yyyy'}} {{event.EndDateTime | date: 'HH:mm'}}</p>
    <p *ngIf="!IsMultiDayEvent" class="py-1 m-0 px-2">{{event.StartDateTime | date:'HH:mm'}}-{{event.EndDateTime | date: 'HH:mm'}}</p>
</div>